export const transformFilesToBase64 = (
  files: File[]
): Promise<
  {
    name: string;
    data: string | ArrayBuffer | null;
  }[]
> => {
  return Promise.all(
    files.map(
      (file) =>
        new Promise<{ name: string; data: string | ArrayBuffer | null }>((resolve) => {
          const reader = new FileReader();
          reader.onload = (event) => {
            resolve({
              name: file.name,
              data: event.target?.result ?? null // Ensure it's never undefined
            });
          };
          reader.readAsDataURL(file);
        })
    )
  );
};
